import { createFileRoute } from "@tanstack/react-router";
import SchedulePage from "@/pages/SchedulePage";
export const Route = createFileRoute("/contactus")({
  component: RouteComponent,
  head() {
    return {
      meta: [
        {
          title: "Schedule a Consultation | Neuro Wellness TMS",
        },
        {
          name: "description",
          content:
            "Schedule a free consultation or initial evaluation for TMS, SAINT®, SPRAVATO®, or medication management at Neuro Wellness TMS Centers of America in Coral.",
        },
        {
          property: "og:title",
          content: "Schedule a Consultation | Neuro Wellness TMS",
        },
        {
          property: "og:description",
          content:
            "Schedule a free consultation or initial evaluation for TMS, SAINT®, SPRAVATO®, or medication management at Neuro Wellness TMS Centers of America in Coral.",
        },
        {
          property: "og:url",
          content: "https://neurowellnesstms.com/contactus",
        },
        {
          property: "og:type",
          content: "website",
        },
        {
          name: "twitter:card",
          content: "summary_large_image",
        },
      ],
      links: [
        {
          rel: "canonical",
          href: "https://neurowellnesstms.com/contactus",
        },
      ],
    };
  },
});
function RouteComponent() {
  return <SchedulePage />;
}
